import { FC, PropsWithChildren } from 'react';
import { MeshBackground, RadialFade, Row, StreemStackedLogoLegal } from '@streem/ui-react';
import ForgotPasswordForm from '../../forms/forgot_password_form';
import { LoginWrapper } from './login_page';
import config from '../../config';

export const CentralLoginForgotPasswordPage: FC<PropsWithChildren> = () => {
    return (
        <MeshBackground>
            <LoginWrapper>
                <Row alignItems="center" justifyContent="center">
                    <RadialFade>
                        <StreemStackedLogoLegal color="white" width="400px" height="300px" />
                    </RadialFade>
                </Row>
                <ForgotPasswordForm companyCode={config.centralLoginAppName} />
            </LoginWrapper>
        </MeshBackground>
    );
};
